"use strict";

var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var clsx_1 = __importDefault(require("clsx"));

var withStyles_1 = require("../styles/withStyles");

var createStyles_1 = require("../styles/createStyles");

var icons_1 = require("@material-ui/icons");

var __1 = require("..");

var util_1 = require("../styles/util");

var styles = function styles(_ref) {
  var palette = _ref.palette;
  return createStyles_1.createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      listStyle: 'none',
      margin: 0,
      padding: 0
    },
    nav: {},
    button: {
      padding: '.15em .25em',
      minWidth: '2.15em',
      letterSpacing: 0,
      '&:focus': {
        boxShadow: '0 0 3px 2px #2765d9'
      }
    },
    ellipsis: {
      color: palette.grey[500] + " !important",
      cursor: 'default !important',
      fontWeight: 'bold',
      letterSpacing: '0.04em'
    },
    active: {
      border: "1px solid " + palette.grey[500],
      backgroundColor: palette.grey[200]
    },
    paginationLabel: {
      textTransform: 'none'
    }
  });
};

var Pagination = React.forwardRef(function (_ref2, ref) {
  var classes = _ref2.classes,
      className = _ref2.className,
      totalItemCount = _ref2.totalItemCount,
      _ref2$itemsPerPage = _ref2.itemsPerPage,
      itemsPerPage = _ref2$itemsPerPage === void 0 ? 10 : _ref2$itemsPerPage,
      _ref2$activePage = _ref2.activePage,
      activePage = _ref2$activePage === void 0 ? 1 : _ref2$activePage,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'expanded' : _ref2$variant,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'small' : _ref2$size,
      onChange = _ref2.onChange,
      navLabel = _ref2.navLabel,
      padding = _ref2.padding,
      margin = _ref2.margin;

  var _React$useState = React.useState(activePage),
      currentPage = _React$useState[0],
      setCurrentPage = _React$useState[1];

  var _React$useState2 = React.useState(currentPage - 1),
      previousPage = _React$useState2[0],
      setPreviousPage = _React$useState2[1];

  var _React$useState3 = React.useState(currentPage + 1),
      nextPage = _React$useState3[0],
      setNextPage = _React$useState3[1];

  var _React$useState4 = React.useState([]),
      pageArray = _React$useState4[0],
      setPageArray = _React$useState4[1];

  var totalPages = Math.ceil(totalItemCount / itemsPerPage);
  var navLabelValue = navLabel || 'pagination';
  var displayNumbers = variant === 'expanded';
  var PageElement = displayNumbers ? 'li' : React.Fragment;
  var WrapElement = displayNumbers ? 'ul' : 'div';
  React.useEffect(function () {
    handleSetPage(activePage, false);

    if (displayNumbers) {
      handleCreatePages();
    }
  }, [itemsPerPage]);
  var rootClasses = clsx_1.default(classes.nav, className, util_1.createPaddingClassNames({
    padding: padding
  }), util_1.createMarginClassNames({
    margin: margin
  }));
  var buttonProps = {
    variant: 'text',
    color: 'neutral',
    size: size,
    disableRipple: true,
    classes: {
      root: classes.button
    }
  };

  var handleCreatePages = function handleCreatePages() {
    var boundary = 1;
    var siblingCount = 1;

    var range = function range(start, end) {
      var length = end - start + 1;
      return Array.from({
        length: length
      }, function (_, i) {
        return start + i;
      });
    };

    var startPages = range(1, Math.min(boundary, totalPages));
    var endPages = range(Math.max(totalPages - boundary + 1, boundary + 1), totalPages);
    var siblingsStart = Math.max(Math.min(currentPage - siblingCount, totalPages - boundary - siblingCount * 2 - 1), boundary + 2);
    var siblingsEnd = Math.min(Math.max(currentPage + siblingCount, boundary + siblingCount * 2 + 2), endPages.length > 0 ? endPages[0] - 2 : totalPages - 1);
    var pageItems = [].concat(_toConsumableArray(startPages), _toConsumableArray(siblingsStart > boundary + 2 ? ['start-ellipsis'] : boundary + 1 < totalPages - boundary ? [boundary + 1] : []), _toConsumableArray(range(siblingsStart, siblingsEnd)), _toConsumableArray(siblingsEnd < totalPages - boundary - 1 ? ['end-ellipsis'] : totalPages - boundary > boundary ? [totalPages - boundary] : []), _toConsumableArray(endPages));
    setPageArray(pageItems);
  };

  var handleSetPage = function handleSetPage(page, useOnChange) {
    if (useOnChange === void 0) {
      useOnChange = true;
    }

    setCurrentPage(page);

    if (displayNumbers) {
      handleCreatePages();
    }

    setNextPage(page + 1);
    setPreviousPage(page - 1);

    if (useOnChange && onChange) {
      onChange(page);
    }
  };

  var handleOnChange = function handleOnChange(page) {
    handleSetPage(page);
  };

  var handleNav = function handleNav(direction) {
    var pageIndex = direction === 'next' ? currentPage + 1 : currentPage - 1;
    handleSetPage(pageIndex);
  };

  return React.createElement("nav", {
    className: rootClasses,
    "aria-label": navLabelValue
  }, totalItemCount > itemsPerPage ? React.createElement(WrapElement, {
    ref: ref,
    className: classes.root
  }, React.createElement(PageElement, null, React.createElement(__1.Button, Object.assign({}, buttonProps, {
    "aria-label": "Previous Page",
    disabled: previousPage < 1,
    onClick: function onClick() {
      return handleNav('previous');
    }
  }), React.createElement(icons_1.NavigateBefore, null))), pageArray ? pageArray.map(function (page) {
    var _clsx_1$default;

    var current = page === currentPage ? 'page' : undefined;
    var buttonClasses = clsx_1.default(classes.button, (_clsx_1$default = {}, _clsx_1$default[classes.active] = current, _clsx_1$default));
    return React.createElement(PageElement, {
      key: navLabel + "-" + page
    }, typeof page === 'number' ? React.createElement(__1.Button, Object.assign({}, buttonProps, {
      "aria-label": "Go to page " + page,
      "aria-current": current,
      onClick: function onClick() {
        return handleOnChange(page);
      },
      classes: {
        root: buttonClasses
      }
    }), page) : React.createElement(__1.Button, Object.assign({}, buttonProps, {
      disabled: true,
      classes: {
        root: clsx_1.default(classes.button, classes.ellipsis)
      }
    }), "..."));
  }) : '', !displayNumbers ? React.createElement(__1.Typography, {
    "aria-live": "polite",
    variant: "button",
    className: classes.paginationLabel
  }, "Page ", currentPage + " of " + totalPages) : '', React.createElement(PageElement, null, React.createElement(__1.Button, Object.assign({}, buttonProps, {
    "aria-label": "Next Page",
    disabled: nextPage > totalPages,
    onClick: function onClick() {
      return handleNav('next');
    }
  }), React.createElement(icons_1.NavigateNext, null)))) : React.createElement(__1.Typography, {
    variant: "button",
    className: classes.paginationLabel
  }, "Displaying ", totalItemCount, " of ", totalItemCount));
});
exports.default = withStyles_1.withStyles(styles, {
  name: 'UnifiPagination'
})(Pagination);